import React from 'react';

const FinalCTA = () => {
  return (
    <section className="final-cta">
      <div className="final-inner">
        <p className="final-eyebrow">The Second-Best Time Is Today</p>
        <h2 className="final-headline">Everything you've built deserves<br /><em>your absolute best preparation.</em></h2>
        <p className="final-tagline">Value Beyond Numbers™</p>
        <p className="final-sub">Not a scramble. Not a hope. A plan — five integrated modules, one complete journey, from where you stand today to the closing table.</p>
        <div className="final-btns">
          <a href="#enroll" className="btn-primary">Enroll — Masterclass 16 April 2025</a>
          <a href="mailto:sunilnikhar@digilantsolution.com" className="btn-outline">Write to Sunil Directly</a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
